import React from "react";
import PropTypes from "prop-types";
import { X } from "@phosphor-icons/react";
import {
  Overlay,
  ModalContainer,
  ModalHeader,
  ModalTitle,
  ModalContent,
  ModalText,
  ButtonGroup,
  CancelButton,
  ConfirmButton,
} from "./ConfirmModalStyled";

const ConfirmModal = ({
  isOpen,
  title,
  message,
  onCancel,
  onConfirm,
  cancelText,
  confirmText,
  onClose,
  busy = false,
  busyTitle,
  busyMessage,
  busyText = "Sending…",
}) => {
  if (!isOpen) return null;

  const handleClose = () => {
    if (busy) return;
    if (onClose) {
      onClose();
    } else {
      onCancel();
    }
  };

  const shownTitle = busy ? busyTitle || title : title;
  const shownMessage = busy ? busyMessage || message : message;

  return (
    <Overlay>
      <ModalContainer>
        <ModalHeader>
          <ModalTitle>{shownTitle}</ModalTitle>
          <X
            style={{ cursor: busy ? "not-allowed" : "pointer", opacity: busy ? 0.4 : 1 }}
            size={20}
            onClick={handleClose}
            data-testid="confirm-modal-close"
            aria-disabled={busy}
          />
        </ModalHeader>
        <ModalContent>
          <ModalText>{shownMessage}</ModalText>
        </ModalContent>
        <ButtonGroup>
          {cancelText && (
            <CancelButton onClick={onCancel} disabled={busy}>
              {cancelText}
            </CancelButton>
          )}
          <ConfirmButton
            onClick={onConfirm}
            disabled={busy}
            aria-busy={busy}
          >
            {busy ? busyText : confirmText}
          </ConfirmButton>
        </ButtonGroup>
      </ModalContainer>
    </Overlay>
  );
};

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  cancelText: PropTypes.string.isRequired,
  confirmText: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  busy: PropTypes.bool,
  busyTitle: PropTypes.string,
  busyMessage: PropTypes.string,
  busyText: PropTypes.string,
};

export default ConfirmModal;
